import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  FetchFromServer,
  UpdateToServer
} from "../api/ServerApi";



function ForgotPassword() {
  const [mobile, setMobile] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");



  const navigate = useNavigate();

  const sendOtp = async () => {
    if (!mobile) return alert("Enter mobile number");

    try {
      const result = await FetchFromServer(
  "SendOtpOnWhatsAppbyMobileNumber",
  { MobileNumber: Number(mobile) }
);

      if (Array.isArray(result) && result.length > 0) {
        localStorage.setItem("reset_otp", result[0].Otp);
        localStorage.setItem("reset_mobile", mobile);
        setOtpSent(true);
        alert("OTP sent to WhatsApp.");
      } else {
        alert("Failed to send OTP.");
      }
    } catch (err) {
      console.error('sendOtp error', err);
      if (err && err.isNetwork) {
        alert('Network error: cannot reach server. Try again later.');
      } else {
        alert('Failed to send OTP.');
      }
    }
  };

const resetPassword = async () => {
  const storedOtp = localStorage.getItem("reset_otp");
  const storedMobile = localStorage.getItem("reset_mobile");

  if (!otp || !newPassword || !confirmPassword)
    return alert("Please fill all fields.");

  if (otp !== storedOtp)
    return alert("Incorrect OTP.");

  if (newPassword !== confirmPassword)
    return alert("Passwords do not match.");

  // Step 1: Fetch UserId from mobile number
  const userData = await FetchFromServer(
  "GetUserDetailsbyMobileNumber",
  { MobileNumber: Number(storedMobile) }
);

  const userId = userData?.[0]?.UserId;

  if (!userId) return alert("User not found.");

  // ✅ Step 2: Make the update password API call
  const updateResult = await UpdateToServer("UpdateUsers", {
  UserId: userId,
  Password: newPassword,
});


  // Step 3: Handle result
  if (updateResult.status === "Success" || updateResult.status === true) {
    localStorage.removeItem("reset_otp");
    localStorage.removeItem("reset_mobile");
    alert("Password updated successfully.");
    navigate("/");
  } else {
    alert("Failed to update password.");
  }
};


  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <div style={styles.title}>Reset Password</div>
        <div style={styles.loginBox}>
          {!otpSent ? (
            <>
              <input
                type="text"
                placeholder="Mobile Number"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                style={styles.input}
              />
              <button onClick={sendOtp} style={{ ...styles.button, ...styles.login }}>
                Send OTP
              </button>
            </>
          ) : (
            <>
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                style={styles.input}
              />
              <input
                type="password"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                style={styles.input}
              />
              <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={styles.input}
              />
              <button onClick={resetPassword} style={{ ...styles.button, ...styles.login }}>
                Reset Password
              </button>
            </>
          )}
          <button onClick={() => navigate("/")} style={{ ...styles.button, ...styles.create }}>
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  body: {
    backgroundImage: 'url("https://wallpapers.com/images/hd/usa-chicago-riverwalk-at-night-1jaq0bwc5dc0g6n0.jpg")',
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    margin: 0,
    fontFamily: "Helvetica, Arial, sans-serif",
    height: "100vh",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  title: {
    fontSize: "48px",
    color: "white",
    fontWeight: "bold",
    marginBottom: "20px",
  },
  loginBox: {
    background: "rgba(255,255,255,0.1)",
    padding: "20px",
    width: "340px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    textAlign: "center",
  },
  input: {
    width: "100%",
    padding: "14px",
    margin: "8px 0",
    border: "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "16px",
  },
  button: {
    width: "100%",
    padding: "14px",
    marginTop: "10px",
    fontSize: "16px",
    fontWeight: "bold",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  login: {
    backgroundColor: "#1877f2",
    color: "white",
  },
  create: {
    backgroundColor: "#42b72a",
    color: "white",
  },
};

export default ForgotPassword;
